import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { Credentials } from 'safe'
import { AUTH_USER_LOGIN, AuthTypes, AUTH_USER_LOGOUT, AUTH_USER_THIRDSIGNUP, AUTH_USER_FOURTHSIGNUP, CHANGE_FIRST_TIME } from './actionTypes'
import jwtDecode from 'jwt-decode'
import { AuthService } from '../../services/AuthService'
const server = process.env.REACT_APP_ADMIN_SERVER
const normalServer = process.env.REACT_APP_SERVER_URL
let authInstance = new AuthService()

export const setUserAndToken = ({
  user,
}: {
  user?: any
}): AuthTypes => ({
  type: AUTH_USER_LOGIN,
  payload: { user },
})

export const signIn =
  ({email, password}): ThunkAction<Promise<Response>, {}, {}, AuthTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>) : Promise<any> => {
    try {
      let user = await authInstance.login(email?.toLowerCase(), password)
      // console.log("acceder", user.getSignInUserSession()?.getIdToken().getJwtToken())
      // await authInstance.signUp(email, password)
      // console.log("token...", user.getSignInUserSession()?.getAccessToken().getJwtToken())
      // console.log("decode...", user.getSignInUserSession()?.getAccessToken().decodePayload())
      const credentials = {
        access_token: user.getSignInUserSession()?.getIdToken().getJwtToken(),
        // refresh_token: response.data.refresh_token,
        // timeToLeave: decode.exp
      }
      localStorage.setItem('credentials', JSON.stringify(credentials))
      return credentials
    } catch (err) {
      throw err
    }
    // if (user.getSignInUserSession()?.getAccessToken().getJwtToken() !== undefined) {
      //@ts-ignore
      // console.log("decode 2.0...", jwtDecode(user.getSignInUserSession()?.getAccessToken().getJwtToken() ) )
    // }
    // console.log("user...", user)
    // await authInstance.signUp(email)
    // await authInstance.confirmSignUp(email, "429485")

    // try {
    //   let url = `${server}/auth/sign-in`
    //   const response = await axios.post(
    //     url,
    //     {email: formValues.email, password: formValues.password}
    //   )
    //   console.log("VER", jwtDecode(response.data.access_token))
    //   let decode : any = jwtDecode(response.data.access_token)
    //   dispatch(setUserAndToken({ user: decode }))
      
    //   return response.data
    // } catch (error) {
    //   throw error
    // }
  }

  // export const signUpFirst = (formValues) : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  // async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {
    
  //   // authInstance.signUp(formValues.email, formValues.password)
  // }

  // export const signUpSecond = (formValues) : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  // async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {
    
  //   // authInstance.signUp(formValues.email, formValues.password)
  // }

  // export const signUpThird

  export const signUp = ({email, password, name, uuid, userPlan}, image?) : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {
    try {
      await authInstance.signUp(email, password, name, uuid, userPlan)
      dispatch({
        type: AUTH_USER_FOURTHSIGNUP,
        payload: {
          image
        }
      })
    } catch (err) {
      throw err
    }
  }

  export const changeFirstTime = () : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {    
    try {
      let resp = await authInstance.changeFirstTime()

      if (resp?.userSub) {
        const response: AxiosResponse = await axios.post(
          `${normalServer}/cognito/confirm`,
          {userId: resp.userSub}
        )
      }

      let newToken = await authInstance.refreshToken()
      const credentials = {
        access_token: newToken
      } 
      // console.log("new token...", newToken)
      localStorage.setItem('credentials', JSON.stringify(credentials))
      // const parsedCredentials = JSON.parse(credentials.access_token)
      let user = jwtDecode(credentials.access_token)
      dispatch(setUserAndToken({user}))
    } catch (err) {
      console.log("LUIS 04", err)
      throw err
    }
  }

  export const changeUserSubscriptionData = (plan: string, subscriptionEnd: Date, subscriptionType: string) : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {    
    try {
    // await authInstance.changeUserSubscriptionData(plan, new Date(subscriptionEnd), subscriptionType)
    let newToken = await authInstance.refreshToken()
      const credentials = {
        access_token: newToken
      } 
      // console.log("new token...", newToken)
      localStorage.setItem('credentials', JSON.stringify(credentials))
      // const parsedCredentials = JSON.parse(credentials.access_token)
      let user = jwtDecode(credentials.access_token)
      dispatch(setUserAndToken({user}))
    } catch (err) {
      throw err
    }
  }

  export const refreshToken = () : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {    
    let newToken = await authInstance.refreshToken()
        
      const credentials = {
        access_token: newToken
      } 

      localStorage.setItem('credentials', JSON.stringify(credentials))

      let user = jwtDecode(credentials.access_token)
      dispatch(setUserAndToken({user}))
  }
  
  export const confirmSignUp = ({email, code}) : ThunkAction<Promise<Response>, {}, {}, AuthTypes> => 
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<any> => {
    try {
      await authInstance.confirmSignUp(email, code)
    } catch (err) {
      throw err
    }
  }

  // export const confirmSignUp = async ({email, code}) => {
  //   try {
  //     await authInstance.confirmSignUp(email, code)
  //   } catch (err) {
  //     throw err
  //   }
  // }


export const authChallenge =
  (formValues): ThunkAction<Promise<Response>, {}, {}, AuthTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AuthTypes>): Promise<Response> => {
    try {
      const response: AxiosResponse = await axios.post(
        `${server}/login/authChallenge`,
        formValues
      )
      if (response.data.user && response.data.authentication) {
        // dispatch(setUserAndToken({ user: response.data.user, token: response.data.authentication }));
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

export const logOut = () => {
  return {
    type: AUTH_USER_LOGOUT
  }
}